import { endpoints } from "src/utils/axios";

import { createObjectHook, createPartialUpdateAction } from '../utils/create-action';

// ======================================================================
// User Context Endpoints
// ======================================================================

const endpoint = endpoints.me;

/**
 * Hook to fetch current user details
 * Supports extend=true query parameter to include roles, stores, and instores
 * @param {Object} args - Fetch arguments (params, config, etc.)
 * @returns {Object} { data, loading, error, validating, empty, refresh }
 */
export const useGetCurrentUser = createObjectHook(endpoint.details);

/**
 * Update current user's settings (e.g., home_dashboard)
 * operates on the current authenticated user and doesn't need an ID in the URL
 */
export const updateCurrentUser = createPartialUpdateAction(endpoint.details, {
    payloadTransformer: (data) => ({
        homeDashboard: data.homeDashboard,
    }),
    idField: null,
});
